import _find from 'lodash/find';

const TOGGLE_FRAUD_POPUP_VISIBLE = `conversions/TOGGLE_FRAUD_POPUP_VISIBLE`;
const INIT_FRAUD_POPUP = `conversions/INIT_FRAUD_POPUP`;

const TOGGLE_RESEND_POPUP = `conversions/TOGGLE_RESEND_POPUP`;

// initState
const initialState = {
	isFraudPopupVisible: false,
	resendConversionPopupAutoTrashId: false
};

// actions
const actions = {
	initFraudPopup: (selectedPayouts) => ({
		type: TOGGLE_FRAUD_POPUP_VISIBLE,
		payload: selectedPayouts
	}),
	toggleFraudPopup: () => ({
		type: TOGGLE_FRAUD_POPUP_VISIBLE
	}),
	toggleResendPopup: (ban_id) => ({ type: TOGGLE_RESEND_POPUP, payload: ban_id })
};

// reducers
const reducers = {
	[TOGGLE_FRAUD_POPUP_VISIBLE]: (state, action) => ({
		...state,
		isFraudPopupVisible: !state.isFraudPopupVisible,
		payoutsToReject: action.payload
	}),
	[INIT_FRAUD_POPUP]: (state, action) => ({
		...state,
		isFraudPopupVisible: true,
		payoutsToReject: action.payload
	}),
	[TOGGLE_RESEND_POPUP]: (state, action) => ({
		...state, resendConversionPopupAutoTrashId: action.payload || null
	})
};

// selectors
const selectors = {
	getIsFraudPopupVisible: state => !!state.conversions.isFraudPopupVisible,
	getResendConversionPopupAutoTrashId: state => state.unacceptableConversions.resendConversionPopupAutoTrashId,
	getResendPopupAutotrashConversionData: state => {
		const { data, resendConversionPopupAutoTrashId } = state.unacceptableConversions;
		if (!data || !resendConversionPopupAutoTrashId) {
			return {};
		}
		return _find(data, { id: resendConversionPopupAutoTrashId });
	},
	getConversionsToMarkCount: state => state.conversions.data && state.conversions.data.length
};

export default {
	initialState,
	actions,
	reducers,
	selectors
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/popups/index.js